/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { debug } from '@/core/debug'
import { ctx } from '@/util/context'
import { queryParam } from '@/util/queryParams'

export const ERROR_PROBE_PARAM = 'errorProbe'

export interface ErrorProbe {
    rejectUnhandled(message: string): void
    throwFromTimer(message: string): void
    handle(message: string): void
}

declare global {
    interface Window {
        __bullfrogErrorProbe?: ErrorProbe
    }
}

const { errorHandler } = ctx('errorProbe')

export function errorProbeEnabled(): boolean {
    return debug && queryParam(ERROR_PROBE_PARAM) === 'true'
}

/** Exposes one trigger per error path for the error-reporting e2e; opt-in via `?errorProbe=true` in debug mode. */
export function installErrorProbe(): void {
    window.__bullfrogErrorProbe = {
        rejectUnhandled: (message) => {
            // oxlint-disable-next-line typescript/no-floating-promises -- the unhandled rejection is the probe
            Promise.reject(new Error(message))
        },
        throwFromTimer: (message) => {
            setTimeout(() => {
                throw new Error(message)
            }, 0)
        },
        handle: (message) => errorHandler(new Error(message)),
    }
}
